import type { ReactNode } from 'react'

import s from './SectionHeading.module.css'

type SectionHeadingProps = {
  children: ReactNode
  /** `h2` unless the page's outline needs the next level down. */
  as?: 'h2' | 'h3'
  id?: string
}

/**
 * The one section heading. TONIGHT, THIS WEEK, FRESHLY CURATED, a venue's month, an act's
 * "coming up" — every folio line on the site is this element with this class, and nothing
 * else styles an `h2` that is a section heading.
 *
 * It exists because the front page's headers were not one font: `FoldableSection` set
 * Futura and `JustAdded`, the section beside it, set nothing and fell to the text face — and
 * five pages had written the same heading five ways, each file styling its own `h2`. One
 * object, so the next section cannot drift; a test greps the stylesheets for a second rule.
 */
export function SectionHeading({ children, as: Tag = 'h2', id }: SectionHeadingProps) {
  return (
    <Tag className={s.heading} id={id}>
      {children}
    </Tag>
  )
}
